import {RemoveFavourites, RemoveFavouritesCallback} from "@next/eventservice"
import {updateFavourites} from "../../ducks/productSummary"
import {FAV_REMOVE} from "../../config/constants"

const removeFavouritesESB = new RemoveFavourites()

export const PublishRemoveFromFav = (data, itemNumber) => (dispatch: any) => {
    const removeFavCallback = new RemoveFavouritesCallback()
    const SubscribeRemoveFromFav = cb => {
        return removeFavCallback.subscribe(cb)
    }
    SubscribeRemoveFromFav(d => {
        if (d.eventId === data.eventId) {
            removeFavCallback.UnsubscribeAll()
            dispatch(updateFavourites(d, FAV_REMOVE, itemNumber))
        }
    })
    removeFavouritesESB.publish(data)
}
